import React from "react";
import { Box, Typography, Stack } from "@mui/material";

interface CollectionCodeProps {
  code: string; // The collection code to display (e.g., "ABC123")
}

const CollectionCode: React.FC<CollectionCodeProps> = ({ code }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      sx={{ marginY: 4 }}
    >
      {code.split("").map((char, index) => (
        <Box
          key={index}
          sx={{
            width: 50,
            height: 50,
            backgroundColor: "#1976d2",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: "bold",
            }}
          >
            {char}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default CollectionCode;
